var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('protocoloProcessoComponenteVue',{attrs:{"detalhe":_vm.detalhe,"modal":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }